import {WikiPageListPage} from "./pages/admin/employee/wiki";
import {SECTION_MARKETING, WikiPageEditPage} from "./pages/admin/employee/wiki/form";
import {NoteAlt as WikiIcon} from "@mui/icons-material";
import {Route} from "react-router-dom";
import * as React from "react";
import SideBarItem from "./sidebar_item";
import {Business, Contacts, Timeline, Assignment, PersonAddAlt1, Share, Article, Campaign, Insights, HourglassBottom} from "@mui/icons-material";
import {MarketingLayout} from "./pages/admin/marketing/layout";
import {AdminMarketingPage} from "./pages/admin/marketing";
import {OrganizationListPage} from "./pages/admin/marketing/organization";
import {OrganizationEditPage} from "./pages/admin/marketing/organization/form";
import {ContactListPage} from "./pages/admin/marketing/contact";
import {ContactEditPage} from "./pages/admin/marketing/contact/form";
import {ContactEventListPage} from "./pages/admin/marketing/contact_event";
import {ContactEventEditPage} from "./pages/admin/marketing/contact_event/form";
import {OrgRequestListPage} from "./pages/admin/marketing/org_request";
import {OrgRequestEditPage} from "./pages/admin/marketing/org_request/form";
import {PresalesPage} from "./pages/admin/marketing/presales";
import {LeadListPage} from "./pages/admin/marketing/lead";
import {LeadEditPage} from "./pages/admin/marketing/lead/form";
import {SocialAccountListPage} from "./pages/admin/marketing/social_account";
import {SocialAccountEditPage} from "./pages/admin/marketing/social_account/form";
import {SocialPostListPage} from "./pages/admin/marketing/social_post";
import {SocialPostEditPage} from "./pages/admin/marketing/social_post/form";
import {SocialPublicationListPage} from "./pages/admin/marketing/social_publication";
import {SocialPublicationEditPage} from "./pages/admin/marketing/social_publication/form";
import {SocialInsightListPage} from "./pages/admin/marketing/social_insight";
import {SocialInsightEditPage} from "./pages/admin/marketing/social_insight/form";

const AdminMarketingRoutes = () => {
    return (
        <Route path="/app/admin/marketing" element={<MarketingLayout/>}>
            <Route index element={<AdminMarketingPage/>}/>

            <Route path="/app/admin/marketing/organization" element={<OrganizationListPage/>}/>
            <Route path="/app/admin/marketing/organization/:id" element={<OrganizationEditPage/>}/>
            <Route path="/app/admin/marketing/organization/new" element={<OrganizationEditPage/>}/>

            <Route path="/app/admin/marketing/contact" element={<ContactListPage/>}/>
            <Route path="/app/admin/marketing/contact/:id" element={<ContactEditPage/>}/>
            <Route path="/app/admin/marketing/contact/new" element={<ContactEditPage/>}/>

            <Route path="/app/admin/marketing/contact-event" element={<ContactEventListPage/>}/>
            <Route path="/app/admin/marketing/contact-event/:id" element={<ContactEventEditPage/>}/>
            <Route path="/app/admin/marketing/contact-event/new" element={<ContactEventEditPage/>}/>

            <Route path="/app/admin/marketing/org-request" element={<OrgRequestListPage/>}/>
            <Route path="/app/admin/marketing/org-request/:id" element={<OrgRequestEditPage/>}/>
            <Route path="/app/admin/marketing/org-request/new" element={<OrgRequestEditPage/>}/>
            <Route path="/app/admin/marketing/presales" element={<PresalesPage/>}/>

            <Route path="/app/admin/marketing/lead" element={<LeadListPage/>}/>
            <Route path="/app/admin/marketing/lead/:id" element={<LeadEditPage/>}/>
            <Route path="/app/admin/marketing/lead/new" element={<LeadEditPage/>}/>

            <Route path="/app/admin/marketing/social-account" element={<SocialAccountListPage/>}/>
            <Route path="/app/admin/marketing/social-account/:id" element={<SocialAccountEditPage/>}/>
            <Route path="/app/admin/marketing/social-account/new" element={<SocialAccountEditPage/>}/>

            <Route path="/app/admin/marketing/social-post" element={<SocialPostListPage/>}/>
            <Route path="/app/admin/marketing/social-post/:id" element={<SocialPostEditPage/>}/>
            <Route path="/app/admin/marketing/social-post/new" element={<SocialPostEditPage/>}/>

            <Route path="/app/admin/marketing/social-publication" element={<SocialPublicationListPage/>}/>
            <Route path="/app/admin/marketing/social-publication/:id" element={<SocialPublicationEditPage/>}/>

            <Route path="/app/admin/marketing/social-insight" element={<SocialInsightListPage/>}/>
            <Route path="/app/admin/marketing/social-insight/:id" element={<SocialInsightEditPage/>}/>
			<Route path="/app/admin/marketing/wiki" element={<WikiPageListPage section={SECTION_MARKETING}/>}/>
			<Route path="/app/admin/marketing/wiki/:id" element={<WikiPageEditPage section={SECTION_MARKETING}/>}/>
			<Route path="/app/admin/marketing/wiki/new" element={<WikiPageEditPage section={SECTION_MARKETING}/>}/>
        </Route>
    );
}

export default AdminMarketingRoutes;

export const AdminMarketingMenu = () => {
    return (
        <>
            <SideBarItem
                href={"/app/admin/marketing/organization"}
                label={"Organizaciones"}
                icon={<Business/>}
            />
            <SideBarItem
                href={"/app/admin/marketing/contact"}
                label={"Contactos"}
                icon={<Contacts/>}
            />
            <SideBarItem
                href={"/app/admin/marketing/contact-event"}
                label={"Interacciones"}
                icon={<Timeline/>}
            />
            <SideBarItem
                href={"/app/admin/marketing/org-request"}
                label={"Oportunidades"}
                icon={<Assignment/>}
            />
            <SideBarItem
                href={"/app/admin/marketing/presales"}
                label={"Preventa"}
                icon={<HourglassBottom/>}
            />
            <SideBarItem
                href={"/app/admin/marketing/lead"}
                label={"Leads"}
                icon={<PersonAddAlt1/>}
            />
            <SideBarItem
                href={"/app/admin/marketing/social-account"}
                label={"Redes conectadas"}
                icon={<Share/>}
            />
            <SideBarItem
                href={"/app/admin/marketing/social-post"}
                label={"Posts sociales"}
                icon={<Article/>}
            />
            <SideBarItem
                href={"/app/admin/marketing/social-publication"}
                label={"Publicaciones"}
                icon={<Campaign/>}
            />
            <SideBarItem
                href={"/app/admin/marketing/social-insight"}
                label={"Métricas"}
                icon={<Insights/>}
            />
            <SideBarItem href={"/app/admin/marketing/wiki"} label={"Wiki"} icon={<WikiIcon/>}/>
        </>
    )
}
